import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/vuex/app';
import auth from '@/vuex/auth';
import tenants from '@/vuex/tenants';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    tenants,
  },
  strict: debug,
});
